import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { RutValidator } from 'ng9-rut';
import * as moment from 'moment';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { AuthService } from 'src/app/services/auth.service';
import { Contact } from 'src/app/models/contact.model';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { Procesox } from 'src/app/models/procesox.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { FaseService } from 'src/app/services/fase.service';
import { ToastrService } from 'ngx-toastr';
import { ValidadorFechasService } from 'src/app/services/formsvalidators/validadorfechas.service';
import {Sostenedor} from '../../../models/sostenedor.model';
import {SostenedorService} from '../../../services/sostenedor.service';
declare var $: any;

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css'],
})
export class PersonalComponent implements OnInit {
  @Input() Alumno: Contact;
  @Input() FaseActual: string;
  @Input() GoToContrato: boolean;
  @Output() AlumnoOut: EventEmitter<Contact> = new EventEmitter();
  @Output() Fase: EventEmitter<string> = new EventEmitter();
  @Output() onGoToContrato: EventEmitter<string> = new EventEmitter();
  @Output() MayorEdad: EventEmitter<boolean> = new EventEmitter();
  habilitaBotones = true;
  habilitaBotonesAdecuaciones: boolean = false
  cargandoDatos = true;
  cargaDatosAlu = false;
  cargaDatosApo = false;
  cargaAnhosEgreso = false;
  cargaRegionApo = false;
  cargaPais = false;
  cargaEstablecimientos = true;
  cargaRegionAlu = false;
  cargaComunaAlu = false;
  user: any

  progress = false;
  alertError = false;
  alertSucces = false;
  btnEnviar = false;
  PerfilForm: FormGroup;
  validarionsRut: any;
  Nacionalidades: any[];
  Regiones: any[];
  RegionesApo: any[];
  RegionesColegios: any[];
  Comunas: any[];
  Comunas2: any[];
  Ciudades: any[];
  Ciudades2: any[];
  Paises: any[];
  Establecimientos: any[];
  AnhosEgresos: any[];
  mayorEdad = false;
  idx = '';

  idChile = '1b8b4414-1615-e511-80c5-00155dfd1662';

  constructor(
    private contactservice: ContactService,
    private sostenedorservice: SostenedorService,
    private fb: FormBuilder,
    private rutValidator: RutValidator,
    private mantenedor: MantenedorService,
    private auths: AuthService,
    private serviceProceso: ProcesoMatriculaService,
    private routes: Router,
    private route: ActivatedRoute,
    public faseService: FaseService,
    public alerts: ToastrService,
    private validadorFechasService: ValidadorFechasService
  ) {
    this.validarionsRut = rutValidator;

    this.PerfilForm = this.fb.group({
      SerialRut: [
        '',
        // [
        //   Validators.required,
        //   Validators.pattern(
        //     /^([0-9]{9})$|^([0-9]{3}\.[0-9]{3}\.[0-9]{3})$|^([A][0-9]{9})$/
        //   ),
        // ],
      ],
      Nombre: [
        '',
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(3),
        ],
      ], //OK -
      Nombre2: ['', [Validators.maxLength(60), Validators.minLength(3)]], //OK -
      ApellidoP: [
        '',
        [
          Validators.maxLength(50),
          Validators.minLength(3),
        ],
      ], //OK -
      ApellidoM: ['', [Validators.maxLength(50), Validators.minLength(3)]], //OK -
      Rut: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          this.validarionsRut,
          Validators.minLength(3),
        ],
      ], //OK -
      Passaporte: [''],
      CorreoElectronico: ['', [Validators.email]], //OK -
      Telefono: ['', [/*Validators.pattern(/^([(]{1}[2]{1}[)]{1}\s[0-9]{8})$/)*/]],
      Celular: [
        '',
        [Validators.required, Validators.maxLength(9), Validators.minLength(8)],
      ], //OK -
      TipoDocumentos: ['1'], //OK -
      Nacionalidad: [''], //OK -
      FechaNacimiento: [
        '',
        [
          Validators.required,
          this.ValidarFecha,
          this.validadorFechasService.EntreAños(17, 71),
        ],
      ], //OK -
      Region: [''], //OK -
      Comuna: [''], //OK -
      Ciudad: [''], //OK -
      Calle: [''], //OK -
      CalleNro: [''], //OK -
      CalleDpto: [''], //OK -
      Banco: [''], //OK -
      TipoDeCuenta: [''], //OK -
      NroDeCuenta: [''], //OK -
      PresentaDiscapacidad: [''], //OK -
      Genero: [''], //OK
      EstadoCivil: [''], //OK
      EnsenhazaMediaEextranjero: [false], //OK
      PrimeroMedioExterior: [false], //OK
      SegundoMedioExterior: [false], //OK
      TerceroMedioExterior: [false], //OK
      CuartoMedioExterior: [false], //OK
      CuarsandoCuartoMedio: [''],
      CurseEnsenhanzaModalidad: [false], //OK // NO SE USA
      AnhoEgresoEM: [''], //OK
      RegionEstudio: [''], //OK
      EstablecimientoEducacionl: [''], //OK
      TipoDependencia: [''],
      CursoEM2x1: [false], //OK
      PrimeroMedio2x1: [false], //OK
      SegundoMedio2x1: [false], //OK
      TerceroMedio2x1: [false], //OK
      CuartoMedio2x1: [false], //OK
      DeseaRecibirAsesoria: [false], //OK
      Etnia: [''], //OK
      Pais: [this.idChile], //OK
      CertificadoCulminacionEM: [false], //OK
      IdContacto: [''], //OK
      BloqueoFinanciero: [false], //OK
      ARut: [''],
      ANombre: [''],
      AApellido: [''],
      AFechaN: [''],
      ARegion: [''],
      AComuna: [''],
      ADireccion: [''],
      ATelefono: [''],
      ACorreo: [''],
      Aserialrut: [''],
      EsApoderado: [false],
      FasePortal: ['3'],
      IdProceso: [''],
    });

    this.route.params.subscribe((params) => {
      this.idx = params.id;
      this.PerfilForm.controls.IdProceso.setValue(this.idx);
    });
    var user = this.auths.GetUserToken();
    if (user !== null) {
      this.alerts.info(
        'Cargando informacion del Alumno',
        'Fase  1 Datos personales'
      );
      this.contactservice.GetContactFull(user.primarysid, '').subscribe(
        (data: Contact) => {
          this.AlumnoOut.emit(data);
          this.PerfilForm.controls['Nombre'].setValue(data.Nombre);
          this.PerfilForm.controls['Nombre2'].setValue(data.Nombre2);
          this.PerfilForm.controls['ApellidoP'].setValue(data.ApellidoP);
          this.PerfilForm.controls['ApellidoM'].setValue(data.ApellidoM);
          this.PerfilForm.controls['Rut'].setValue(data.Rut);


          this.PerfilForm.controls['CorreoElectronico'].setValue(
            data.CorreoElectronico
          );
          if (data.Telefono && data.Telefono.trim().length > 0)
            // && data.Telefono.trim() !== "2")
            this.PerfilForm.controls['Telefono'].setValue(
              this.formatearTelefonoBD(data.Telefono, true)
            );
          this.PerfilForm.controls['Celular'].setValue(data.Celular);
          this.PerfilForm.controls['Calle'].setValue(data.Calle);
          this.PerfilForm.controls['CalleNro'].setValue(data.CalleNro);
          this.PerfilForm.controls['CalleDpto'].setValue(data.CalleDpto);
          this.PerfilForm.controls['Banco'].setValue(data.Banco);
          this.PerfilForm.controls['TipoDeCuenta'].setValue(data.TipoDeCuenta);
          this.PerfilForm.controls['NroDeCuenta'].setValue(data.NroDeCuenta);
          this.PerfilForm.controls['IdContacto'].setValue(data.IdContacto);
          //this.PerfilForm.controls['SerialRut'].setValue(data.SerialRut);
          this.PerfilForm.controls['SerialRut'].setValue(
            this.formatearSerieRutBD(data.SerialRut)
          );

          this.enableFormPersona(false);
          //fecha
          const vNac = moment(data.FechaNacimiento, 'DD-MM-YYYY');
          if (vNac.isValid())
            this.PerfilForm.controls['FechaNacimiento'].setValue(
              moment(data.FechaNacimiento, 'DD-MM-YYYY').format('YYYY-MM-DD')
            );
          else
            this.PerfilForm.controls['FechaNacimiento'].setValue(
              moment(data.FechaNacimiento, 'MM-DD-YYYY').format('YYYY-MM-DD')
            );

          const fechax = moment(
            this.PerfilForm.controls.FechaNacimiento.value,
            'YYYY-MM-DD'
          );
          const fechaActual = moment().format('YYYY-MM-DD');
          if (fechax.diff(fechaActual, 'years') > -18) {
            //Requerido los campos del apoderado
            this.AddRequeridos();
          } else {
            //quitar los requeridos
            this.RemoveApoderado();
          }
          this.mantenedor.getRegion().subscribe(
            (datax: any) => {
              this.Regiones = datax.Result;
              this.RegionesApo = datax.Result;
              if (data.Region !== null) {
                this.PerfilForm.controls.Region.setValue(data?.Region?.Id);
                this.mantenedor.getCiudad(data.Region.Id).subscribe(
                  (datac: any) => {
                    this.Ciudades = datac.Result;
                    this.PerfilForm.controls['Ciudad'].setValue(data.Ciudad.Id);
                    this.cargaRegionAlu = true;
                    this.validaDatosCargados();
                  },
                  (err) => console.log(err)
                );
                this.mantenedor
                  .getComuna(data.Region.Id)
                  .subscribe((datar: any) => {
                    this.Comunas = datar.Result;
                    this.PerfilForm.controls['Comuna'].setValue(data.Comuna.Id);
                    this.cargaComunaAlu = true;
                    this.validaDatosCargados();
                  });
              }
              this.cargaDatosAlu = true;
              this.validaDatosCargados();
            },
            (err) => { }
          );

          if (this.idx != '' && this.idx != null) {
            this.contactservice.GetInfoApoderado(this.idx).subscribe(
              (datap: Procesox) => {
                this.PerfilForm.controls.ARut.setValue(datap.RutApoderado);
                var nombreAp = datap.NombreApoderado.split(' ');
                if (nombreAp.length > 1) {
                  this.PerfilForm.controls.ANombre.setValue(nombreAp[0]);
                  this.PerfilForm.controls.AApellido.setValue(nombreAp[1]);
                } else {
                  this.PerfilForm.controls.ANombre.setValue(nombreAp[0]);
                }
                console.log(datap.FechaNacimientoApoderado);
                this.PerfilForm.controls.AFechaN.setValue(
                  moment(datap.FechaNacimientoApoderado, 'YYYY/MM/DD').format(
                    'YYYY-MM-DD'
                  )
                );
                //this.PerfilForm.controls.ARegion.setValue(datap.SerialAceptante)
                //this.PerfilForm.controls.AComuna.setValue(datap.SerialAceptante)
                this.PerfilForm.controls.ADireccion.setValue(
                  datap.DireccionApoderado
                );
                this.PerfilForm.controls.ATelefono.setValue(
                  datap.TelefonoCelularApoderado
                );
                this.PerfilForm.controls.ACorreo.setValue(
                  datap.CorreoElectronicoApoderado
                );
                this.PerfilForm.controls.Aserialrut.setValue(
                  this.formatearSerieRutBD(datap.SerialAceptante)
                );
                this.PerfilForm.controls['DeseaRecibirAsesoria'].setValue(
                  datap.DeseaAsesoria
                );

                if (datap.RegionApoderado !== null) {
                  this.PerfilForm.controls.ARegion.setValue(
                    datap.RegionApoderado.Id
                  );

                  this.mantenedor.getComuna(datap.RegionApoderado.Id).subscribe(
                    (datar: any) => {
                      this.Comunas2 = datar.Result;
                      if (datap.ComunaApoderado !== null) {
                        this.PerfilForm.controls.AComuna.setValue(
                          datap.ComunaApoderado.Id
                        );
                      }
                      this.cargaRegionApo = true;
                      this.validaDatosCargados();
                    },
                    (err) => { },
                    () => { }
                  );
                }
                this.cargaDatosApo = true;
                this.validaDatosCargados();
                console.log(this.PerfilForm)
              },
              (err) => {
                console.log(err);
              }
            );
          }
          //Boolean
          this.PerfilForm.controls['EnsenhazaMediaEextranjero'].setValue(
            data.EnsenhazaMediaEextranjero
          );
          this.PerfilForm.controls['PrimeroMedioExterior'].setValue(
            data.PrimeroMedioExterior
          );
          this.PerfilForm.controls['SegundoMedioExterior'].setValue(
            data.SegundoMedioExterior
          );
          this.PerfilForm.controls['TerceroMedioExterior'].setValue(
            data.TerceroMedioExterior
          );
          this.PerfilForm.controls['CuartoMedioExterior'].setValue(
            data.CuartoMedioExterior
          );
          this.PerfilForm.controls['CursoEM2x1'].setValue(data.CursoEM2x1);
          this.PerfilForm.controls['BloqueoFinanciero'].setValue(
            data.BloqueoFinanciero
          );
          this.PerfilForm.controls['CurseEnsenhanzaModalidad'].setValue(
            data.CurseEnsenhanzaModalidad
          ); // NO SE USA
          this.PerfilForm.controls['PrimeroMedio2x1'].setValue(
            data.PrimeroMedio2x1
          );
          this.PerfilForm.controls['SegundoMedio2x1'].setValue(
            data.SegundoMedio2x1
          );
          this.PerfilForm.controls['TerceroMedio2x1'].setValue(
            data.TerceroMedio2x1
          );
          this.PerfilForm.controls['CuartoMedio2x1'].setValue(
            data.CuartoMedio2x1
          );
          this.PerfilForm.controls['CertificadoCulminacionEM'].setValue(
            data.CertificadoCulminacionEM
          );
          //OptionSet
          this.PerfilForm.controls['Etnia'].setValue(data.Etnia?.Value);
          this.PerfilForm.controls['Genero'].setValue(data.Genero?.Value);
          this.PerfilForm.controls['EstadoCivil'].setValue(
            data.EstadoCivil?.Value
          );
          this.PerfilForm.controls['TipoDocumentos'].setValue(
            data.TipoDocumentos?.Value
          );
          this.PerfilForm.controls['Nacionalidad'].setValue(
            data.Nacionalidad?.Value
          );
          this.PerfilForm.controls['PresentaDiscapacidad'].setValue(
            data.PresentaDiscapacidad?.Value
          );
          //number
          this.mantenedor.getAnhoEgreso().subscribe(
            (datae: any) => {
              this.AnhosEgresos = datae.Result;
              if (data.AnhoEgresoEM !== null) {
                this.PerfilForm.controls['AnhoEgresoEM'].setValue(
                  data.AnhoEgresoEM.Value
                );
              }
              this.cargaAnhosEgreso = true;
              this.validaDatosCargados();
            },
            (err) => { }
          );

          //Lookups
          this.mantenedor.getPais().subscribe(
            (datax: any) => {
              this.Paises = datax.Result;
              if (data.Pais !== null) {
                this.PerfilForm.controls['Pais'].setValue(data.Pais.Id);
              } else {
                this.PerfilForm.controls['Pais'].setValue(this.idChile);
              }
              this.cargaPais = true;
              this.validaDatosCargados();
            },
            (error) => { }
          );
          if (this.idx != '' && this.idx != null) {
            this.habilitaBotones = false;
            /*FVARAS:  Comento esto, ya que al crear un nuevo proceso (Adecuaciones) éste es creado antes de entrar a datos personales
                      y es requerido mostrar los datos al usuario antes de pasar a Arancel De Carrera.
             */
            // this.Fase.emit('2');
            // this.faseService.fase$.emit('2');
            // this.Fase.emit('2');

            this.serviceProceso.GetProceso(this.idx).subscribe(proceso => {
              if (proceso.FasePortal.Value == '1') {
                this.habilitaBotonesAdecuaciones = true
                this.Fase.emit('1');
                this.faseService.fase$.emit('1');
                this.Fase.emit('1');
              } else {
                this.Fase.emit('2');
                this.faseService.fase$.emit('2');
                this.Fase.emit('2');
              }
            })
          }
          this.cargandoDatos = false;
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  ChangeNacionalidad(event: any) {
    const id = event.target.value;
    if (id === '1') {
      //chilena vlidar rut
      this.PerfilForm.controls.Rut.setValidators([
        Validators.required,
        Validators.maxLength(50),
        this.validarionsRut,
        Validators.minLength(3),
      ]);
      this.PerfilForm.controls.SerialRut.setValidators([
        Validators.required,
        Validators.pattern(
          /^([0-9]{9})$|^([0-9]{3}\.[0-9]{3}\.[0-9]{3})$|^([A][0-9]{9})$/
        ),
      ]);
      this.PerfilForm.controls.Rut.updateValueAndValidity();
      this.PerfilForm.controls.SerialRut.updateValueAndValidity();
      this.PerfilForm.controls.Passaporte.clearValidators();
      this.PerfilForm.controls.Passaporte.updateValueAndValidity();
    } else {
      this.PerfilForm.controls.Rut.clearValidators();
      this.PerfilForm.controls.SerialRut.clearValidators();
      this.PerfilForm.controls.Rut.updateValueAndValidity();
      this.PerfilForm.controls.SerialRut.updateValueAndValidity();
      this.PerfilForm.controls.Passaporte.setValidators([Validators.required]);
      this.PerfilForm.controls.Passaporte.updateValueAndValidity();
    }
  }
  RemoveApoderado() {
    console.log("mayorEdad", this.mayorEdad)
    this.mayorEdad = true;

    this.MayorEdad.emit(true);
    console.log("mayorEdad", this.mayorEdad)
    this.PerfilForm.controls.EsApoderado.setValue(true);
    this.PerfilForm.controls.ARut.clearValidators();
    this.PerfilForm.controls.ANombre.clearValidators();
    this.PerfilForm.controls.AApellido.clearValidators();
    this.PerfilForm.controls.AFechaN.clearValidators();
    this.PerfilForm.controls.ARegion.clearValidators();
    this.PerfilForm.controls.AComuna.clearValidators();
    this.PerfilForm.controls.ADireccion.clearValidators();
    this.PerfilForm.controls.ATelefono.clearValidators();
    this.PerfilForm.controls.ACorreo.clearValidators();
    this.PerfilForm.controls.Aserialrut.clearValidators();
    this.PerfilForm.controls.ARut.updateValueAndValidity();
    this.PerfilForm.controls.ANombre.updateValueAndValidity();
    this.PerfilForm.controls.AApellido.updateValueAndValidity();
    this.PerfilForm.controls.AFechaN.updateValueAndValidity();
    this.PerfilForm.controls.ARegion.updateValueAndValidity();
    this.PerfilForm.controls.AComuna.updateValueAndValidity();
    this.PerfilForm.controls.ADireccion.updateValueAndValidity();
    this.PerfilForm.controls.ATelefono.updateValueAndValidity();
    this.PerfilForm.controls.ACorreo.updateValueAndValidity();
    this.PerfilForm.controls.Aserialrut.updateValueAndValidity();
  }
  AddRequeridos() {
    this.mayorEdad = false;

    this.MayorEdad.emit(false);
    this.PerfilForm.controls.EsApoderado.setValue(false);
    this.PerfilForm.controls.ARut.setValidators([
      Validators.required,
      Validators.maxLength(12),
      this.validarionsRut,
      Validators.minLength(3),
    ]);
    this.PerfilForm.controls.ANombre.setValidators([
      Validators.required,
      Validators.maxLength(50),
      Validators.minLength(3),
      this.validarNombre
    ]);
    this.PerfilForm.controls.AApellido.setValidators([
      Validators.required,
      Validators.maxLength(50),
      Validators.minLength(3),
    ]);
    this.PerfilForm.controls.AFechaN.setValidators([
      Validators.required,
      this.ValidarFecha,
      // this.validadorFechasService.MayorDeAños(18),
      this.validadorFechasService.EntreAños(17, 71),
    ]);
    //this.PerfilForm.controls.ARegion.setValidators([Validators.required]);
    //this.PerfilForm.controls.AComuna.setValidators([Validators.required]);
    //this.PerfilForm.controls.ADireccion.setValidators([Validators.required]);
    this.PerfilForm.controls.ATelefono.setValidators([
      Validators.required,
      Validators.maxLength(9),
      Validators.minLength(8),
    ]);
    this.PerfilForm.controls.ACorreo.setValidators([
      Validators.email,
      Validators.required,
    ]);
    this.PerfilForm.controls.Aserialrut.setValidators([
      Validators.required,
      Validators.pattern(
        /^([0-9]{9})$|^([0-9]{3}\.[0-9]{3}\.[0-9]{3})$|^([A][0-9]{9})$/
      ),
    ]);
    this.PerfilForm.controls.ARut.updateValueAndValidity();
    this.PerfilForm.controls.ANombre.updateValueAndValidity();
    this.PerfilForm.controls.AApellido.updateValueAndValidity();
    this.PerfilForm.controls.AFechaN.updateValueAndValidity();
    //this.PerfilForm.controls.ARegion.updateValueAndValidity();
    //this.PerfilForm.controls.AComuna.updateValueAndValidity();
    //this.PerfilForm.controls.ADireccion.updateValueAndValidity();
    this.PerfilForm.controls.ATelefono.updateValueAndValidity();
    this.PerfilForm.controls.ACorreo.updateValueAndValidity();
    this.PerfilForm.controls.Aserialrut.updateValueAndValidity();
  }

  ngOnInit(): void {
    this.user = this.auths.GetUserToken();
    if (this.TieneBloqueoAcademico()) {
      this.openModalBloqueoAcademico();
    }
  }

  changeFechaNacimieno() {
    const fechax = moment(
      this.PerfilForm.controls.FechaNacimiento.value,
      'YYYY-MM-DD'
    );
    const fechaActual = moment().format('YYYY-MM-DD');
    if (fechax.diff(fechaActual, 'years') > -18) {
      //Requerido los campos del apoderado
      this.AddRequeridos();
    } else {
      //quitar los requeridos
      this.RemoveApoderado();
    }
  }
  TieneBloqueoAcademico() {
    console.log('this.user.BloqueoAcademico'+this.user.BloqueoAcademico)
    if (this.user.BloqueoAcademico && this.user.BloqueoAcademico === 'True')
      return true
    return false
  }

  openModalBloqueoAcademico() {
    $('#modalBloqueoAcademico').modal('show');
  }

  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  ValidarFecha(control: FormControl): { [s: string]: boolean } {
    const fechaActual = moment().format('YYYY-MM-DD');
    if (control.value >= fechaActual) {
      return {
        novalido: false,
      };
    }
    return null;
  }
  validarNombre(control: FormControl) {
    if (control.value.split(' ').length > 1 && control.value.split(' ')[0].length > 3 && control.value.split(' ')[1].length > 2) {
      console.log('valido true');
      return null;
    } else {
      return {
        novalido: false
      };

    }


  }
  ChangeRegion(event: any) {
    const id = event.target.value;
    if (id === '') {
      return;
    }
    this.mantenedor.getCiudad(id).subscribe(
      (data: any) => {
        this.Ciudades = data.Result;
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
    this.mantenedor.getComuna(id).subscribe(
      (data: any) => {
        this.Comunas = data.Result;
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
  }
  ChangeRegion2(event: any) {
    const id = event.target.value;
    if (id === '') {
      return;
    }
    this.mantenedor.getCiudad(id).subscribe(
      (data: any) => {
        this.Ciudades2 = data.Result;
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
    this.mantenedor.getComuna(id).subscribe(
      (data: any) => {
        this.Comunas2 = data.Result;
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
  }

  ChangeRegionColegio(event: any) {
    const id = event.target.value;
    if (id === '') {
      return;
    }
    this.mantenedor.getestablecimientoeducacionl(id).subscribe(
      (data: any) => {
        this.Establecimientos = data.Result;
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
  }

  formatearTelefono(formato: boolean) {
    var largo = this.PerfilForm.controls.Telefono.value.length;
    var data = this.PerfilForm.controls.Telefono.value;
    if (data === '') {
      return;
    }
    if (formato) {
      this.PerfilForm.controls.Telefono.setValue('2' + data.slice(4, 12));
    } else if (largo == 1 && data[0] != '(' && !formato) {
      this.PerfilForm.controls.Telefono.setValue('(2) ' + data);
    }
  }

  formatearTelefonoBD(num: string, bd: boolean) {
    if (this.PerfilForm.controls.Telefono.value.length == 9 && !bd) {
      var data = this.PerfilForm.controls.Telefono.value;
      this.PerfilForm.controls.Telefono.setValue('(2) ' + data.slice(1, 10));
    } else if (bd) {
      if (num == '') {
        return '';
      } else {
        return '(2) ' + num.slice(1, 10);
      }
    }
  }

  formatearSerieRut() {
    var largo = this.PerfilForm.controls.SerialRut.value.length;
    var data = this.PerfilForm.controls.SerialRut.value;
    if (data[0] != 'A' && largo == 9 && data[3] != '.' && data[7] != '.') {
      data = data.slice(0, 3) + '.' + data.slice(3, 6) + '.' + data.slice(6, 9);
    }
    this.PerfilForm.controls.SerialRut.setValue(data);
  }

  formatearSerieRutBD(nom: string) {
    if (nom === null) {
      return '';
    }
    var data = nom;
    if (nom != null) {
      if (nom[0] != 'A') {
        data =
          data.slice(0, 3) + '.' + data.slice(3, 6) + '.' + data.slice(6, 9);
      }
    }

    return data;
  }

  formatearSerieRutSinPuntos() {
    if (this.PerfilForm.controls.SerialRut.valid) {
      var data = this.PerfilForm.controls.SerialRut.value;
      if (data[0] != 'A') {
        data = data.slice(0, 3) + data.slice(4, 7) + data.slice(8, 11);
        this.PerfilForm.controls.SerialRut.setValue(data);
      }
    }
  }

  formatearASerieRut() {
    var largo = this.PerfilForm.controls.Aserialrut.value.length;
    var data = this.PerfilForm.controls.Aserialrut.value;
    if (data[0] != 'A' && largo == 9 && data[3] != '.' && data[7] != '.') {
      data = data.slice(0, 3) + '.' + data.slice(3, 6) + '.' + data.slice(6, 9);
    }
    this.PerfilForm.controls.Aserialrut.setValue(data);
  }

  formatearASerieRutSinPuntos() {
    if (this.PerfilForm.controls.Aserialrut.valid) {
      var data = this.PerfilForm.controls.Aserialrut.value;
      if (data[0] != 'A') {
        data = data.slice(0, 3) + data.slice(4, 7) + data.slice(8, 11);
        this.PerfilForm.controls.Aserialrut.setValue(data);
      }
    }
  }
  validaDatosCargados() {
    if (
      this.cargaDatosAlu &&
      this.cargaDatosApo &&
      this.cargaAnhosEgreso &&
      this.cargaRegionApo &&
      this.cargaPais &&
      this.cargaEstablecimientos &&
      this.cargaRegionAlu &&
      this.cargaComunaAlu
    ) {
      this.cargandoDatos = false;
    }
  }
  checkRut(event: any) {
    // Despejar Puntos
    var id = event.target.value;
    var valor = id.replace('.', '');
    // Despejar Guión
    valor = valor.replace('-', '');

    // Aislar Cuerpo y Dígito Verificador
    var cuerpo = valor.slice(0, -1);
    var dv = valor.slice(-1).toUpperCase();

    // Formatear RUN
    id = cuerpo + '-' + dv;

    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    if (cuerpo.length < 7) {
      this.PerfilForm.controls.ARut.setValue(null);
      this.PerfilForm.controls.ARut.updateValueAndValidity();
      return false;
    }

    // Calcular Dígito Verificador
    var suma = 0;
    var multiplo = 2;

    // Para cada dígito del Cuerpo
    for (var i = 1; i <= cuerpo.length; i++) {
      // Obtener su Producto con el Múltiplo Correspondiente
      var index = multiplo * valor.charAt(cuerpo.length - i);

      // Sumar al Contador General
      suma = suma + index;

      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) {
        multiplo = multiplo + 1;
      } else {
        multiplo = 2;
      }
    }

    // Calcular Dígito Verificador en base al Módulo 11
    var dvEsperado = 11 - (suma % 11);

    // Casos Especiales (0 y K)
    dv = dv == 'K' ? 10 : dv;
    dv = dv == 0 ? 11 : dv;

    // Validar que el Cuerpo coincide con su Dígito Verificador
    if (dvEsperado != dv) {
      this.PerfilForm.controls.ARut.setValue(null);
      this.PerfilForm.controls.ARut.updateValueAndValidity();
      return false;
    }
  }

  Actualizar() {
    this.validateAllFormFields(this.PerfilForm);
    if (this.PerfilForm.valid) {
      this.progress = true;
      this.formatearSerieRutSinPuntos();
      this.formatearASerieRutSinPuntos();
      this.formatearTelefono(true);
      this.PerfilForm.controls.FasePortal.setValue('1');
      const contacto = new Contact(this.PerfilForm.value);
      this.contactservice.UpdateContact(contacto).subscribe(
        (data) => {
          this.alertSucces = true;
          setTimeout(() => {
            this.alertSucces = false;
            this.progress = false;
          }, 7000);
        },
        (err) => {
          this.alertError = true;
          setTimeout(() => {
            this.alertError = false;
            this.progress = false;
          }, 7000);
        },
        () => {
          this.progress = false;
        }
      );
      this.formatearSerieRut();
      //this.formatearASerieRut();
      this.formatearTelefonoBD(' ', false);
    } else {
      console.log(this.PerfilForm);
    }
  }

  guardar_y_Actualizar() {
    this.validateAllFormFields(this.PerfilForm);
    if (this.PerfilForm.valid) {
      this.PerfilForm.controls.FasePortal.setValue('3');
      this.progress = true;
      this.formatearSerieRutSinPuntos();
      this.formatearASerieRutSinPuntos();
      if (this.PerfilForm.controls['Telefono'].value.trim().length > 0)
        this.formatearTelefono(true);
      var contacto = new Contact(this.PerfilForm.value);
      if (this.idx !== '' && this.idx !== null) contacto.IdProceso = this.idx;
      this.AlumnoOut.emit(contacto);
      this.contactservice.UpdateContact(contacto).subscribe(
        (data) => {
          var proceso = new Procesox(this.PerfilForm.value);
          if (this.idx !== '' && this.idx !== null) {
            proceso.IdProceso = this.idx;
          }
          proceso.NombreApoderado =
            this.PerfilForm.controls.ANombre.value +
            ' ' +
            this.PerfilForm.controls.AApellido.value;
          this.serviceProceso.CrearProceso(proceso).subscribe(
            (rs: any) => {
              this.alertSucces = true;
              if (!rs.Error) {
                this.routes.navigate(['/proceso', rs.Id]);
              }
              this.alertSucces = false;
              this.progress = false;
            },
            (er) => {
              this.alertError = true;
              setTimeout(() => {
                this.alertError = false;
                this.progress = false;
              }, 7000);
            },
            () => { }
          );
        },
        (err) => {
          this.alertError = true;
          setTimeout(() => {
            this.alertError = false;
            this.progress = false;
          }, 7000);
        },
        () => {
          this.progress = false;
        }
      );
      this.formatearSerieRut();
      //this.formatearASerieRut();
      this.formatearTelefonoBD(' ', false);
    } else {
      console.log(this.PerfilForm);
    }
  }

  // guardar_e_ir_a_contrato() {
  //   this.validateAllFormFields(this.PerfilForm);
  //   if (this.PerfilForm.valid) {
  //     // this.PerfilForm.controls.FasePortal.setValue('2');
  //     this.progress = true;
  //     //TODO: Descomentar (solo para pruebas)
  //     // this.formatearSerieRutSinPuntos();
  //     // this.formatearASerieRutSinPuntos();
  //     // this.formatearTelefono(true);
  //     var contacto = new Contact(this.PerfilForm.value);
  //     if (this.idx !== "" && this.idx !== null)
  //       contacto.IdProceso = this.idx;
  //     // if (!this.GoToContrato) {
  //     //   console.log('[PERSONAL] AlumnoOut Emit')
  //     //   this.AlumnoOut.emit(contacto);
  //     // }

  //     this.alerts.success('Datos modificados')
  //     this.onGoToContrato.emit(contacto.IdProceso);
  //     this.progress = false;
  //     return;

  //     this.contactservice.UpdateContact(contacto).subscribe(
  //       (data) => {
  //         if (this.GoToContrato) {
  //           this.alerts.success('Datos modificados')
  //           this.onGoToContrato.emit(contacto.IdProceso);
  //           return;
  //         }
  //       },
  //       (err) => {
  //         this.alertError = true;
  //         setTimeout(() => {
  //           this.alertError = false;
  //           this.progress = false;

  //         }, 7000);
  //       },
  //       () => {
  //         this.progress = false;
  //       }
  //     );
  //     this.formatearSerieRut();
  //     //this.formatearASerieRut();
  //     this.formatearTelefonoBD(" ", false);
  //   } else {
  //     console.log(this.PerfilForm)
  //   }
  // }

  ngOnChanges(): void { }

  guardar() {
    this.validateAllFormFields(this.PerfilForm);
    if (this.PerfilForm.valid) {
      this.progress = true;
      this.formatearSerieRutSinPuntos();
      this.formatearASerieRutSinPuntos();

      if (this.PerfilForm.controls['Telefono'].value.trim().length > 0)
        this.formatearTelefono(true);

      this.PerfilForm.controls.FasePortal.setValue('1');
      const contacto = new Contact(this.PerfilForm.value);
      this.AlumnoOut.emit(contacto);
      this.contactservice.UpdateContact(contacto).subscribe(
        (data) => {
          var proceso = new Procesox(this.PerfilForm.value);
          proceso.NombreApoderado =
            this.PerfilForm.controls.ANombre.value +
            ' ' +
            this.PerfilForm.controls.AApellido.value;
          if (this.idx !== '' && this.idx !== null) {
            proceso.IdProceso = this.idx;
          }
          this.serviceProceso.CrearProceso(proceso).subscribe(
            (rs: any) => {
              this.alertSucces = true;
              setTimeout(() => {
                if (!rs.Error) {
                  this.routes.navigate(['/proceso', rs.Id]);
                }
                this.alertSucces = false;
                this.progress = false;
              }, 7000);
            },
            (er) => {
              this.alertError = true;
              setTimeout(() => {
                this.alertError = false;
                this.progress = false;
              }, 7000);
            },
            () => { }
          );
        },
        (err) => {
          this.alertError = true;
          setTimeout(() => {
            this.alertError = false;
            this.progress = false;
          }, 7000);
        },
        () => {
          this.progress = false;
        }
      );
      //this.formatearASerieRut();
      this.formatearSerieRut();
      this.formatearTelefonoBD(' ', false);
    } else {
      console.log(this.PerfilForm);
    }
  }

  enableFormPersona(enable: boolean = true) {
    if (enable) {
      this.PerfilForm.controls.SerialRut.enable();
      this.PerfilForm.controls.Rut.enable();
      this.PerfilForm.controls.Nombre.enable();
      this.PerfilForm.controls.Nombre2.enable();
      this.PerfilForm.controls.ApellidoP.enable();
      this.PerfilForm.controls.ApellidoM.enable();
      this.PerfilForm.controls.FechaNacimiento.enable();
      this.PerfilForm.controls.Celular.enable();
      this.PerfilForm.controls.CorreoElectronico.enable();
    } else {
      this.PerfilForm.controls.SerialRut.disable();
      this.PerfilForm.controls.Rut.disable();
      this.PerfilForm.controls.Nombre.disable();
      this.PerfilForm.controls.Nombre2.disable();
      this.PerfilForm.controls.ApellidoP.disable();
      this.PerfilForm.controls.ApellidoM.disable();
      this.PerfilForm.controls.FechaNacimiento.disable();
      this.PerfilForm.controls.Celular.disable();
      this.PerfilForm.controls.CorreoElectronico.disable();
    }
  }

  async confirmar_y_Actualizar() {
    //this.enableFormPersona();
    // this.validateAllFormFields(this.PerfilForm);
    if (!this.mayorEdad) {
      this.PerfilForm.get('ARut').markAsTouched()
      this.PerfilForm.get('Aserialrut').markAsTouched()
      this.PerfilForm.get('ANombre').markAsTouched()
      this.PerfilForm.get('AApellido').markAsTouched()
      this.PerfilForm.get('AFechaN').markAsTouched()
      this.PerfilForm.get('ATelefono').markAsTouched()
      this.PerfilForm.get('ACorreo').markAsTouched()
    }
    if (!this.PerfilForm.valid) {
      return
    }
    this.PerfilForm.controls.FasePortal.setValue('3');
    this.progress = true;
    this.formatearSerieRutSinPuntos();
    this.formatearASerieRutSinPuntos();
    if (this.PerfilForm.controls['Telefono'].value.trim().length > 0)
      this.formatearTelefono(true);
    var contacto = new Contact(this.PerfilForm.value);
    if (this.idx !== '' && this.idx !== null) contacto.IdProceso = this.idx;
    this.AlumnoOut.emit(contacto);
    this.enableFormPersona(false);
    const updContactResult = await this.contactservice.UpdateContact(contacto).toPromise()
    if (!this.mayorEdad) {
      var sostenedor = new Sostenedor({});
      sostenedor.ARut = this.PerfilForm.get("ARut").value;
      sostenedor.ACorreo = this.PerfilForm.get("ACorreo").value;
      sostenedor.AFechaN = this.PerfilForm.get("AFechaN").value;
      sostenedor.AApellido = this.PerfilForm.get("AApellido").value;
      sostenedor.Aserialrut = this.PerfilForm.get("Aserialrut").value;
      sostenedor.ATelefono = this.PerfilForm.get("ATelefono").value;
      sostenedor.ANombre = this.PerfilForm.get("ANombre").value;
      sostenedor.IdProceso = this.idx
      const updSostenedorResult = await this.sostenedorservice.UpdateSostenedor(sostenedor).toPromise()
    }
    // var proceso = new Procesox(this.PerfilForm.value);
    // if (this.idx !== '' && this.idx !== null) {
    //   proceso.IdProceso = this.idx;
    // }
    // proceso.NombreApoderado =
    //   this.PerfilForm.controls.ANombre.value +
    //   ' ' +
    //   this.PerfilForm.controls.AApellido.value;

    const idProceso = this.idx
    const setFaseResult = await this.serviceProceso.setFase(idProceso, '3').toPromise()

    // this.routes.navigateByUrl(`/proceso/${idProceso}`);
    // this.routes.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    //   this.routes.navigateByUrl(`/proceso/${idProceso}`));
    // this.Fase.emit('3');
    // this.faseService.fase$.emit('3');
    // this.Fase.emit('3');
    location.reload();
  }
}
